import { Model } from 'components/discovery/utils/model.js'

export type ImageHotspotProduct = {
  image: string,
  priceConsumer: number | null,
  priceCurrency: string | null,
  priceCustomer: number | null,
  priceSale: number | null,
  rating: number,
  ratingCount: number,
  stock: number | null,
  stockMessage: string | null,
  url: string,
  description: string,
  id: number,
  name: string,
}

export type ExternalImageHotspotProduct = {
  id: number,
  name: string,
  description: string,
  page_link: string,
  picture: {
    normal: string,
  },
  prices: {
    consumer: number | null,
    currency_code: string | null,
    customer: number | null,
    sale: number | null,
  },
  rating: {
    main: {
      value: number | null,
      count: number,
    }
  },
  stock: {
    amount: number | null,
    message: string | null,
  }
}

export class ExternalImageHotspotProductModel extends Model<ExternalImageHotspotProduct> implements ExternalImageHotspotProduct {
  id = 0
  name = ''
  description = ''
  page_link = ''
  picture = {
    normal: ''
  }
  prices = {
    consumer: 0,
    currency_code: '',
    customer: 0,
    sale: 0,
  }
  rating = {
    main: {
      value: null,
      count: 0,
    }
  }
  stock = {
    amount: 0,
    message: '',
  }

  parseToInternalRepresentation = (): ImageHotspotProduct => ({
    description: this.description,
    id: this.id,
    image: this.picture.normal,
    name: this.name,
    priceConsumer: this.prices.consumer,
    priceCurrency: this.prices.currency_code,
    priceCustomer: this.prices.customer,
    priceSale: this.prices.sale,
    rating: this.rating.main.value ?? 0,
    ratingCount: this.rating.main.count,
    stock: this.stock.amount,
    stockMessage: this.stock.message,
    url: this.page_link,
  })
}

export const defaultProduct = new ExternalImageHotspotProductModel().parseToInternalRepresentation()
